import React, { useEffect } from "react";
import ClassNames from "classnames";
//import { section, onlyMobile, sectionBgYellow,  sectionBgGrey, sectionBgLightGrey, cxTalksVid, sectionBgGamingExp, sectionBgOrangeHome} from "./styles.scss"

import * as s from "./s.module.scss";

const Section = ({
  id,
  variant,
  children,
  className,
  containerRef,
  onScreen,
  onScreenOffsetTop,
  progressStart,
  onlyMobile,
  ...props
}) => {
  useEffect(() => {
    let scrollId;
    let offsetTop = onScreenOffsetTop ? onScreenOffsetTop : 0;
    const setMessage = () => {
      clearTimeout(scrollId);
      scrollId = setTimeout(() => {
        if (
          containerRef &&
          containerRef.current &&
          containerRef.current.getBoundingClientRect() &&
          containerRef.current.getBoundingClientRect().top <= offsetTop
        ) {
          onScreen && onScreen();
        }
      }, 100);
    };
    setMessage();
    window.addEventListener("scroll", setMessage);
    window.addEventListener("drag", setMessage);

    return () => {
      window.removeEventListener("scroll", setMessage);
      window.removeEventListener("drag", setMessage);
    };
  }, [containerRef]);

  const sectionType = {
    [s.sectionBgYellow]: variant === "sectionBgYellow",
    [s.sectionBgGrey]: variant === "sectionBgGrey",
    [s.sectionBgWhite]: variant === "sectionBgWhite",
    [s.sectionBgLightGrey]: variant === "sectionBgLightGrey",
    [s.cxTalksVid]: variant === "cxTalksVid",
    [s.sectionBgGamingExp]: variant === "sectionBgGamingExp",
    [s.sectionBgOrangeHome]: variant === "sectionBgOrangeHome",
    [s.sectionBgOrangeFintech]: variant === "sectionBgOrangeFintech",
    [s.sectionBgFintech]: variant === "sectionBgFintech",
    [s.sectionBgFintechMeetup]: variant === "sectionBgFintechMeetup",
    [s.sectionBgGamingMeetup]: variant === "sectionBgGamingMeetup",
    [s.sectionBgGamingMeetupLanding]:
      variant === "sectionBgGamingMeetupLanding",
    [s.sectionBgTechMeetup]: variant === "sectionBgTechMeetup",
    [s.sectionBgTechRegister]: variant === "sectionBgTechRegister",
    [s.sectionBgCxTalkTravelFiresidesMain]:
      variant === "sectionBgCxTalkTravelFiresidesMain",
    [s.sectionBgEcommerceMeetup]: variant === "sectionBgEcommerceMeetup",
    [s.sectionBgEcommerce]: variant === "sectionBgEcommerce",
    [s.sectionBgTravel]: variant === "sectionBgTravel",
    [s.sectionBgTravelBg]: variant === "sectionBgTravelBg",
    [s.sectionBgCXPowerfulAI]: variant === "sectionBgCXPowerfulAI",
    [s.sectionBgCXPowerfulAI2]: variant === "sectionBgCXPowerfulAI2",
    [s.sectionBgWorkLifeBlock]: variant === "sectionBgWorkLifeBlock",
    [s.sectionBgTestimonial]: variant === "sectionBgTestimonial",
    [s.sectionBgBone]: variant === "sectionBgBone",
  };

  return (
    <div
      id={id}
      className={ClassNames(
        s.section,
        sectionType,
        { [s.onlyMobile]: onlyMobile },
        className
      )}
      ref={containerRef}
      {...props}
    >
      {children}
    </div>
  );
};

export default Section;
